// @lib-export
var MathN;
(function (MathN) {
    MathN[MathN["ZERO"] = 0] = "ZERO";
    MathN[MathN["DOT_ONE"] = 0.1] = "DOT_ONE";
    MathN[MathN["ONE"] = 1] = "ONE";
    MathN[MathN["TWO"] = 2] = "TWO";
    MathN[MathN["EIGHT"] = 8] = "EIGHT";
    MathN[MathN["TEN"] = 10] = "TEN";
    MathN[MathN["SIXTY"] = 60] = "SIXTY";
    MathN[MathN["HUNDRED"] = 100] = "HUNDRED";
    MathN[MathN["FIVE_HUNDRED"] = 500] = "FIVE_HUNDRED";
    MathN[MathN["SIX_HUNDRED"] = 600] = "SIX_HUNDRED";
    MathN[MathN["THOUSAND"] = 1000] = "THOUSAND";
    MathN[MathN["TWO_THOUSAND"] = 2000] = "TWO_THOUSAND";
})(MathN || (MathN = {}));

export { MathN };
//# sourceMappingURL=math-n.js.map
